/**
 * Super Admin App
 *
 * Platform administration portal.
 */
import { RouterProvider } from '@tanstack/react-router';
import { Toaster } from '@respectly/ui';
import { router } from './routes/router';

function App() {
  return (
    <>
      <RouterProvider router={router} />
      <Toaster />
    </>
  );
}

export default App;
